import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    sipParams: [],
    sipParam: null,
    isIncomingCall: false,
    isModalOpen: false,
    isOpenedSession: false,
    isInCall: false,
    phone: null,
    incomingPhone: '',
    sipHistory: [],
    incomingUser: null,
    outgoingUser: null,
    sipHistoryComments: [],
    isCommentsLoaded: false,
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
